/** CoStar.Api.AptsUserTracking.ViewModels.UserSearchFilterOption */
export var UserSearchFilterOption;
(function (UserSearchFilterOption) {
    UserSearchFilterOption[UserSearchFilterOption["None"] = 0] = "None";
    UserSearchFilterOption[UserSearchFilterOption["ExcludeSavedSearches"] = 1] = "ExcludeSavedSearches";
})(UserSearchFilterOption || (UserSearchFilterOption = {}));
import { CommuteTravelMode } from "../../../../CoStar/Api/AptsNet/Aggregate/ViewModels/index.js";
/** CoStar.Api.AptsUserTracking.ViewModels.CommuteTravelMode */
export { CommuteTravelMode };
/** CoStar.Api.AptsUserTracking.ViewModels.Client */
export var Client;
(function (Client) {
    Client[Client["None"] = 0] = "None";
    Client[Client["Website"] = 1] = "Website";
})(Client || (Client = {}));
